import { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import { DataAccessProvider, MMP_SOURCE_MAP } from '@constants/constants';

import AppsFlyerIcon from '@assets/icons/data-source/data_source_apps_flyer.svg';
import AdjustIcon from '@assets/icons/data-source/data_source_adjust.svg';
import AggregatedDataIcon from '@assets/icons/data-source/data_source_aggregated_data.svg';
import UserTrxDataIcon from '@assets/icons/data-source/data_source_user_trx_data.svg';
import NoneIcon from '@assets/icons/data-source/data_source_none.svg';

const DATA_SOURCE_ICON_MAP: Partial<Record<DataAccessProvider, string>> = {
  [DataAccessProvider.APPS_FLYER]: AppsFlyerIcon,
  [DataAccessProvider.ADJUST]: AdjustIcon,
  [DataAccessProvider.AGGREGATED_DATA]: AggregatedDataIcon,
  [DataAccessProvider.NONE]: NoneIcon,
};

interface DataSourceIconProps {
  dataSource?: string;
  size?: number;
}

const DataSourceIcon: FC<DataSourceIconProps> = ({ dataSource, size = 20 }) => {
  const normalizedDataSource =
    !dataSource || dataSource === DataAccessProvider.NONE
      ? DataAccessProvider.NONE
      : (dataSource as DataAccessProvider);

  const iconSrc = DATA_SOURCE_ICON_MAP[normalizedDataSource] ?? UserTrxDataIcon;

  return (
    <Tooltip title={MMP_SOURCE_MAP[normalizedDataSource] ?? normalizedDataSource} arrow>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: '#E8EAEB',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={iconSrc}
          alt={normalizedDataSource}
          sx={{
            width: size - 8,
            height: size - 8,
            flexShrink: 0,
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default DataSourceIcon;
